<div class="row">
     <div class="col-12">
       <div class="row justify-content-between align-items-center" id="page-title">
         <h1 class="progress-header col-12 col-lg-auto" [innerHtml]="'Enroll in PSP_MAIN' | translator:'base'">Enroll in PSP</h1>
       </div>
       <div class="row mb-2">
         <span class="col-12 col-lg-auto d-flex align-items-center small">
           <i class="fas fa-triangle-exclamation me-2" aria-hidden="true"></i>
           <span>Are you a <strong>driver</strong> looking for your own PSP record?</span>
           <a routerLink="/driver/1"
              (click)="scrollToTop()"
              name="Driver-record-request"
              id="Driver-record-request"
              [title]="'Start_8-2' | translator:'base'" 
              class="ms-1" 
           >
             <span [innerHtml]="'Start_8-2' | translator:'base'">Access your PSP record here.</span>
           </a>
         </span>
       </div>
       <div class="row">
         <div class="col-lg-8">
           <div class="card shadow-sm rounded-0 border-0">
             <div class="card-body">
               <app-complete-bar [step]="19" [totalSteps]="19"></app-complete-bar>
               <h2 [innerHtml]="'ENROLLMENT COMPLETE' | translator:'base'">ENROLLMENT COMPLETE!</h2>
               <p>{{ customizeAllDoneMessage() }}</p>
               <hr>
               <p [innerHtml]="'COMPLETE_2' | translator:'base'">What's next:</p>
               <ul>
                 <li [innerHtml]="'COMPLETE_3' | translator:'base'">
                   You will receive a PDF version of the PSP agreement. Please refer to the agreement to fully understand your responsibilities when using PSP.
                 </li>
                 <li [innerHtml]="'COMPLETE_4' | translator:'base'">
                   Your enrollment is under review. After it is approved, you will receive an email notification and you can begin using PSP.
                 </li>
                 <li>
                   <span [innerHtml]="'COMPLETE_5-1' | translator:'base'">If you have any questions, please </span>
                   <a routerLink="/customerSupport"
                      (click)="scrollToTop()"
                      [title]="'COMPLETE_5-2' | translator:'base'"
                      target="_blank"
                      name="customerSupport24"
                      id="customerSupport24"
                   >
                     <span [innerHtml]="'COMPLETE_5-2' | translator:'base'">contact us</span>
                   </a>.
                 </li>
               </ul>
               <a routerLink="/" tag="button" class="btn btn-primary btn-strong"
                  [innerHtml]="'COMPLETE_6' | translator:'base'"
                  [title]="'COMPLETE_6' | translator:'base'"
                  name="PSP-Home"
                  id="PSP-Home"
                  (click)="scrollToTop()"
               >PSP Home</a>
             </div>
           </div>
         </div>
         <app-progress-wizard [wizardObj]="wizardObj" [activeStep]="8"
                    [pageType]="enrollmentService.newCustomer!.customerType || '-'"
                    class="col-lg-4 sidebar d-none d-lg-block"></app-progress-wizard>
       </div>
     </div>
   </div>
   
